import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ReservationService } from 'src/app/services/reservation/reservation.service';

@Component({
  selector: 'app-commission-modal',
  templateUrl: './commission-modal.component.html',
  styleUrls: ['./commission-modal.component.scss']
})
export class CommissionModalComponent {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() loading: boolean;
  @Input() title: string;
  @Input() selectedOutlet: string;
  @Input() selectOutletDetails: any;
  @Output() deleteItem = new EventEmitter();
  submitted: any = false
  success: any = false
  message: string = ''

  constructor(
    private adminService: AdminService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.commissionForm.patchValue(this.selectOutletDetails)
    this.commissionForm.patchValue({
      delivergate_account: this.selectOutletDetails?.delivergate_account.toString(),
    })

  }

  commissionForm: FormGroup = new FormGroup({
    tbl_commission_per_head: new FormControl('', [Validators.required]),
    tbl_ref_commission_per_head: new FormControl('', [Validators.required]),
    transfer_destination: new FormControl(null, [Validators.required]),
    delivergate_account: new FormControl(null, [Validators.required]),
  })
  get controls() { return this.commissionForm.controls; }

  onSaveChanges() {
    this.submitted = true;
    this.loading = true;
    const formData = new FormData();
    // console.log(this.commissionForm.value, "this.commissionForm");

    if (this.commissionForm.invalid) {
      console.log("form is invalid");
      this.loading = false;
    } else {
      formData.append('tbl_commission_per_head', this.commissionForm.value.tbl_commission_per_head)
      formData.append('tbl_ref_commission_per_head', this.commissionForm.value.tbl_ref_commission_per_head)
      formData.append('transfer_destination', this.commissionForm.value.transfer_destination)
      formData.append('delivergate_account', this.commissionForm.value.delivergate_account)
      formData.append('_method', "PUT")

      this.adminService.updateTableReservationCommission(this.selectedOutlet, formData)
        .subscribe({
          next: (res) => {
            console.log(res, "sucess");
            this.loading = false;
            this.success = true;
            this.message = 'Successfully updated the reservation commission'
          },
          error: (error) => {
            console.log(error);
            this.loading = false;
            this.success = false;
            this.message = 'Error updating the reservation commission'
          }
        })
    }
  }

  onDismiss() {
    this.message = ''
    this.submitted = false
  }
}
